var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['stats-laps', _vm.isDetails ? 'stats--details' : '']},[(_vm.isLoading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"stats__loading"}):(_vm.anchors.isEmpty)?_c('h4',[_vm._v(" "+_vm._s(_vm.$t("messages.errorGatewayRequired"))+" ")]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }